import { render } from "./googleAuthenticate.vue?vue&type=template&id=06a3eb5a&scoped=true&ts=true"
import script from "./googleAuthenticate.vue?vue&type=script&lang=ts"
export * from "./googleAuthenticate.vue?vue&type=script&lang=ts"

import "./googleAuthenticate.vue?vue&type=style&index=0&id=06a3eb5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a3eb5a"]])

export default __exports__